import React from 'react';
import { render } from 'react-dom';

import AnnotationPopUp from '../components/mapview/annotation-popup';

/**
 * creates the custom Annotation Popup when user clicks an annotation on the map
 * @param props - object containing an Esri Graphic and a close function
 * @returns AnnotationPopUp component inside the mapview popup
 */
export const createAnnotationPopup = (props: { graphic: __esri.Graphic; close: Function }) => {
  const popupNode = document.createElement('div');
  render(<AnnotationPopUp {...props} />, popupNode);
  return popupNode;
};
